import React, { PropTypes } from "react";

const Attachment = (props) => {
  const attachmentInfo = {
    objectName: props.objectName,
    bucketName: props.bucketName,
    objectPath: props.objectPath,
    regionName: props.regionName,
  };
  return (
    <div
      className="attachment"
      onClick={(proxy) => {
        proxy.stopPropagation();
        return props.handleAttachmentDownload(attachmentInfo);
      }}
    >
      <div className="attachment-thumbnail">
        <span className="icon icon-file-empty" />
      </div>
      <div className="attachment-info">
        <span className="filename" title={props.objectName}>
          {props.objectName}
        </span>
        {!props.readOnly && (
          <span
            className="remove"
            onClick={props.handleAttachmentDelete.bind(this, attachmentInfo)}
          >
            <span className="icon-cross" />
          </span>
        )}
      </div>
    </div>
  );
};

Attachment.propTypes = {
  bucketName: PropTypes.string,
  objectName: PropTypes.string,
  objectPath: PropTypes.string,
  readOnly: PropTypes.bool,
  regionName: PropTypes.string,
  handleAttachmentDownload: PropTypes.func,
  handleAttachmentDelete: PropTypes.func,
};

export default Attachment;



// WEBPACK FOOTER //
// ./src/components/common/attachments/Attachment.js